import { GET } from "Common/api";
import config from "lib/config";
import NavigationStore from "lib/components/leftmenu/Store";
import UserStore from "../stores/user";
import SelectionStore from "../stores/teams";
import MainMenuHelper from "lib/components/leftmenu/mainmenuhelper";
import * as MainMenu from "lib/constants/mainmenu";
import * as TeamFunctionRights from "./constants/teamfunctionrights";

const installationId = config.installationId;
let pLeftMenu = false;

export let getLeftMenu = () => {
  if (!pLeftMenu) {
    pLeftMenu = NavigationStore.reload().then(() =>
      Object.values(NavigationStore.nodes).sort(
        (a, b) => (a.order || 0) - (b.order || 0),
      ),
    );
  }

  return pLeftMenu;
};

export async function getSubMenu(itemId) {
  let leftMenu = await getLeftMenu();

  return leftMenu.filter((m) => m.parentId == itemId);
}

export async function hasRight(itemId) {
  let leftMenu = await getLeftMenu();

  //If user is admin (luvit or system) he should have access to editcomptalk
  if (
    location.href.indexOf("fromadmin") != -1 &&
    (NavigationStore.isAdmin || NavigationStore.isUnitAdmin) &&
    itemId == MainMenu.ID_MANAGER_COMPTALKS
  ) {
    return true;
  }

  if (itemId == 3) {
    //Meddelanden i kursen fungerar inte om man stänger av meddelanden i portalen
    return true;
  }

  if (
    location.href.indexOf("fromadmin") !== -1 &&
    itemId === MainMenu.ID_MANAGER_ACTINGMANAGER
  ) {
    return true;
  }

  if (
    location.href.indexOf("fromadmin") !== -1 &&
    itemId === MainMenu.ID_MANAGER_SEARCHANDFILTER
  ) {
    return true;
  }

  return leftMenu.find((m) => m.itemId == itemId) != null;
}

export async function canViewCoworker(coworkerPersonalId) {
  // Check if the current user has permission to view the current page for a specific coworker.
  let mainMenuItemId = MainMenuHelper.getMainMenuIdFromUrl(
    window.location.href,
  );
  let _canViewCoworker = await GET(
    "/v1/users/:coworkerPersonalId/canviewcoworker/:mainMenuItemId",
    {
      coworkerPersonalId,
      mainMenuItemId,
    },
  );

  return _canViewCoworker;
}

export async function getTmPages() {
  let pages = await getSubMenu(5);

  pages = filterPagesForCoworkerDropdown(pages);
  pages = filterPagesForCurrentTeam(pages);
  pages = filterPagesForAdminUsers(pages);

  // Remove goal and activities item if PEAB and from Admin
  if (installationId == "peab" && UserStore.user.fromAdmin) {
    let idx = pages.findIndex((p) => p.itemId == 46);
    if (idx !== -1) pages.splice(idx, 1);
  }

  return pages;
}

function filterPagesForAdminUsers(pages) {
  if (UserStore.user.fromAdmin) {
    pages = pages.filter(
      (m) =>
        m.itemId !== MainMenu.ID_COWORKER_COMPTALK &&
        m.itemId !== MainMenu.ID_MNU_PRESENTATION,
    );
  }

  return pages;
}

function filterPagesForCoworkerDropdown(pages) {
  return pages.filter(
    (m) => m.section === "TM" && m.itemId !== MainMenu.ID_COWORKER_ENGAGEMENT,
  );
}

function filterPagesForCurrentTeam(pages) {
  if (SelectionStore.active.type !== "team") {
    return pages;
  }

  const permissions = SelectionStore.active.permissions;

  if (permissions.indexOf(TeamFunctionRights.ID_COMPTALK) !== -1) {
    return pages;
  }

  return pages.filter(
    (m) =>
      (m.itemId === MainMenu.ID_COWORKER_CAREERPATHS &&
        permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
          -1) ||
      (m.itemId === MainMenu.ID_COWORKER_COMPETENCEPROFILE &&
        permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
          -1) ||
      (m.itemId === MainMenu.ID_COWORKER_CERTIFICATES &&
        permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
          -1) ||
      (m.itemId === MainMenu.ID_COWORKER_MYCOURSES &&
        (permissions.indexOf(TeamFunctionRights.ID_COURSESTATISTICS) !== -1 ||
          permissions.indexOf(TeamFunctionRights.ID_REGISTERANDCANCEL) !==
            -1)) ||
      (m.itemId === MainMenu.ID_COWORKER_AUTHORISATIONS &&
        permissions.indexOf(TeamFunctionRights.ID_COMPETENCEMANAGEMENT) !==
          -1) ||
      (m.itemId === MainMenu.ID_COWORKER_EDUCATIONHISTORYANDCV &&
        permissions.indexOf(TeamFunctionRights.ID_COURSESTATISTICS) !== -1) ||
      (m.itemId === MainMenu.ID_COWORKER_MYACTIVITIES &&
        permissions.indexOf(TeamFunctionRights.ID_REGISTERANDCANCEL) !== -1) ||
      (m.itemId === MainMenu.ID_COWORKER_GOALSANDACTIVITIES &&
        permissions.indexOf(TeamFunctionRights.ID_GOALSANDACTIVITIES) !== -1) ||
      (m.itemId === MainMenu.ID_COWORKER_DEVELOPMENTPLAN &&
        permissions.indexOf(TeamFunctionRights.ID_GOALSANDACTIVITIES) !== -1),
  );
}

export default {
  getLeftMenu,
  getSubMenu,
  hasRight,
  canViewCoworker,
};
